import(/* webpackMode: "eager" */ "/app/apps/galaxy-web/src/features/providers/header-provider/header-provider.tsx");
